module.exports = __webpack_public_path__ + "static/media/delantal (11).b4a5f0ca.jpg";